import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export function roleGuard(...allowedRoles: string[]): CanActivateFn {
  return () => {
    const router = inject(Router);
    const token = localStorage.getItem('sw_token');
    const userRaw = localStorage.getItem('sw_user');
    if (!token) { router.navigate(['/auth/login']); return false; }
    if (!userRaw || userRaw === 'undefined' || userRaw === 'null') {
      // Authenticated but no user profile stored — allow through, let server decide
      return true;
    }
    try {
      const user = JSON.parse(userRaw);
      // Support both multi-role (roles[]) and legacy single role
      const userRoles: string[] = Array.isArray(user.roles) && user.roles.length > 0
        ? user.roles.map((r: string) => r.toLowerCase())
        : [(user.role ?? '').toLowerCase()];
      if (!userRoles.some(r => !!r) || allowedRoles.some(r => userRoles.includes(r.toLowerCase()))) return true;
      router.navigate(['/dashboard']);
      return false;
    } catch {
      // Corrupt user data — allow through rather than logging out
      return true;
    }
  };
}
